import React,{useState} from 'react'
import Grid from 'components/Custom/Grid'
import { getFieldFormSettings, ProjectConfiguration, deleteFieldForm } from 'utils/ProjectConfigurationUtil';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid'
import GridFieldForms from './FieldForms/GridFieldForms';


const FieldFormsSettings = () => {
    const { selectedProject } = useAppContext() //Getting the App Context
    const columns = ProjectConfiguration.columnsTestFieldFormFields.filter(col => col.title !== "name")
    const title = "Field Forms Settings"
    const getFormPath = () => import('components/ProjectConfiguration/FieldFormTemplate');
    const [updateDate, setUpdateDate] = useState(new Date());
    //Callback to update the Project Configuration Settings
    //TODO: Handle the user selection toggle 
    const receiveSettings = (evt, sectionSettingData) => {
        // const data = JSON.parse(sectionSettingData)
        // do nothing I guess...
    }
    const selection = { "display": false, "callback": receiveSettings, "tooltip": "", "btnText": "Update Settings" }

    return (
        <div key={updateDate}>
            {
                selectedProject ?
                  <GridFieldForms />
                   :
                        <SkeletonGrid title={title} />
            }
        </div>
    )

}

export default FieldFormsSettings
 